import { render, staticRenderFns } from "./UserAdmin.vue?vue&type=template&id=0f554356"
import script from "./UserAdmin.vue?vue&type=script&lang=js"
export * from "./UserAdmin.vue?vue&type=script&lang=js"
import style0 from "./UserAdmin.vue?vue&type=style&index=0&id=0f554356&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports